import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/Index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
		meta: {
			title: '首页'
		}
  },
  {
    path: '/about',
    name: 'about',
		meta: {
			title: '公司介绍'
		},
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
	{
	  path: '/case',
	  name: 'case',
		meta: {
			title: '项目案例'
		},
	  // route level code-splitting
	  // this generates a separate chunk (about.[hash].js) for this route
	  // which is lazy-loaded when the route is visited.
	  component: () => import(/* webpackChunkName: "about" */ '../views/Case.vue')
	},
	{
	  path: '/contact',
	  name: 'contact',
	  // route level code-splitting
	  // this generates a separate chunk (about.[hash].js) for this route
	  // which is lazy-loaded when the route is visited.
	  component: () => import(/* webpackChunkName: "about" */ '../views/Contact.vue')
	},
	{
	  path: '/honor',
	  name: 'honor',
	  // route level code-splitting
	  // this generates a separate chunk (about.[hash].js) for this route
	  // which is lazy-loaded when the route is visited.
	  component: () => import(/* webpackChunkName: "about" */ '../views/Honor.vue')
	},
	{
	  path: '/news',
	  name: 'news',
		meta: {
			keepAlive: true
		},
	  // route level code-splitting
	  // this generates a separate chunk (about.[hash].js) for this route
	  // which is lazy-loaded when the route is visited.
	  component: () => import(/* webpackChunkName: "about" */ '../views/News.vue')
	},
  {
    path: '/products',
    name: 'products',
		meta: {
			keepAlive: true
		},
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Products.vue')
  },
	{
	  path: '/product-detail',
	  name: 'productdetail',
	  // route level code-splitting
	  // this generates a separate chunk (about.[hash].js) for this route
	  component: () => import(/* webpackChunkName: "about" */ '../views/ProductDetail.vue')
	},
	{
	  path: '/news-detail',
	  name: 'newsdetail',
	  // route level code-splitting
	  // this generates a separate chunk (about.[hash].js) for this route
	  component: () => import(/* webpackChunkName: "about" */ '../views/NewsDetail.vue')
	},
	{
	  path: '/case-detail',
	  name: 'casedetail',
	  // route level code-splitting
	  // this generates a separate chunk (about.[hash].js) for this route
	  component: () => import(/* webpackChunkName: "about" */ '../views/CaseDetail.vue')
	},
	{
		path: '*',
		name: 'errorpage',
		component: () => import(/* webpackChunkName: "about" */ '../404.vue')
	}
]

const router = new VueRouter({
	mode: "history",
  routes
})

export default router
